export default __webpack_public_path__ + "static/media/card-level11-sweepstakes.3ea519c9.jpg";